import React, { useMemo } from 'react';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import { DnDQuestionItemV2 } from './DnDQuestionItemV2';
import { DnDAnswerOption } from '../interface';

import s from './DnDQuestionV2.scss';
import { getAreaId } from '../utils';
import { IQuestionPart, AnswerOptionStatus, QuestionPartType } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

export interface IDnDQuestionV2Props {
    content: IQuestionPart[];
    selectedAnswers: { [key: string]: DnDAnswerOption };
    correctAnswers: { [key: string]: AnswerOptionStatus };
    onOptionSelect: (id: number) => void;
    isCode?: boolean;
}

export function DnDQuestionV2({
    content,
    selectedAnswers,
    correctAnswers,
    onOptionSelect,
    isCode,
}: IDnDQuestionV2Props): JSX.Element {
    useStyles(s);
    const onlyDropArea = useMemo(() => {
        const res = {};
        let x = 0;
        content.forEach((c, index) => {
            if (c.type === QuestionPartType.InputBox) {
                res[index] = x;
                x++;
            }
        });
        return res;
    }, [content]);

    const currentInputBoxIndex = getAreaId(selectedAnswers);

    return (
        <div
            className={classNames('sl-dnd-question-v2', {
                code: isCode,
            })}
        >
            {content.map((item, index) => {
                switch (item.type) {
                    case QuestionPartType.Text:
                        return (
                            <div
                                key={index}
                                className={classNames(
                                    'sl-dnd-question-v2__text',
                                    {
                                        code: isCode,
                                    }
                                )}
                            >
                                {item.content}
                            </div>
                        );
                    case QuestionPartType.NewLine:
                        return (
                            <div
                                key={index}
                                sl-test-data="lblSlDndQuestionNewLine"
                                className="sl-dnd-question-v2__new-line"
                            />
                        );
                    case QuestionPartType.InputBox:
                        return (
                            <DnDQuestionItemV2
                                isCode={isCode}
                                key={index}
                                index={onlyDropArea[index]}
                                isCurrent={
                                    currentInputBoxIndex === onlyDropArea[index]
                                }
                                status={correctAnswers[onlyDropArea[index]]}
                                value={selectedAnswers[onlyDropArea[index]]}
                                onSelect={onOptionSelect}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </div>
    );
}
